import * as React from 'react';

const SvgAddRowBefore = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M5.92383 4.5H10.9238M8.42383 2V7", stroke: "currentColor", strokeWidth: 1.8, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ React.createElement("rect", { x: 2.42383, y: 10, width: 12, height: 4, rx: 1, stroke: "currentColor", strokeWidth: 1.8 }));

export { SvgAddRowBefore as default };
//# sourceMappingURL=add-row-before.svg.js.map
